export interface Indicator {
  type: IndicatorTypes;
  value: string;
}

export enum IndicatorTypes {
  MD5 = 'hashMD5',
  SHA1 = 'hashSHA1',
  SHA256 = 'hashSHA256',
  SHA512 = 'hashSHA512',
  FILE_NAME = 'file',
  PROCESS_NAME = 'process',
  REGISTRY_VALUE = 'registryValue',
  REGISTRY_KEY = 'registryKey',
}

export enum IocEvents {
  INDICATOR_ADDED = 'indicator-added',
  INDICATOR_REMOVED = 'indicator-removed',
  CATEGORY_TOGGLED = 'category-toggled',
}

export interface IndicatorConfig {
  indicatorType: IndicatorTypes;
  checkboxLabel: string;
  mainLabel: string;
  textareaPlaceholder: string;
  inputValidationRegex: string;
  inputMaxChars: number;
  hintText: string;
  requiresExtraValidations: boolean;
  entryMinLength?: number;
}

export interface IocScanRequestRules {
  name: string;
  indicators: Array<IndicatorsGroupedByType>;
}

export interface IndicatorsGroupedByType {
  type: IndicatorTypes;
  data: Array<string>;
}

export interface IocScanTaskSpecifics {
  rules: Array<IocScanRequestRules>;
}
